import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, Container } from '@mui/material';
import PrimaryButton from './PrimaryButton';

type Props = {
    title: string;
    subtext: string | React.ReactNode;
    isOpen: boolean;
    handleClose: any;
};

export default function FailureDialog({ title, subtext, isOpen, handleClose }: Props) {
    return (
        <Dialog data-testid="dialog" onClose={handleClose} aria-labelledby="simple-dialog-title" open={isOpen}>
            <DialogTitle classes={{ root: 'failure-title' }}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText classes={{ root: 'failure-subtext' }}>{subtext}</DialogContentText>
            </DialogContent>
            <Container className="failure-button-container">
                <PrimaryButton onClick={handleClose} classes={{ root: 'failure-button' }}>
                    Got it
                </PrimaryButton>
            </Container>
        </Dialog>
    );
}
